@use 'src/core/styles/variables';

.overline {
  display: inline-block;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-note);
  font-weight: bold;
  letter-spacing: variables.$two-px-in-em;
  text-transform: uppercase;
}
